import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=41a0f464&scoped=true"
import script from "./contactDetail.vue?vue&type=script&lang=js"
export * from "./contactDetail.vue?vue&type=script&lang=js"
import style0 from "./contactDetail.vue?vue&type=style&index=0&id=41a0f464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0f464",
  null
  
)

export default component.exports